import StudentDashboard from "components/students/Dashboard";
import AdminStartupDashboard from "components/adminStartup/Dashboard";
import TeacherDashboard from "components/teachers/Dashboard";
import ParentDashboard from "components/parent/Dashboard";
import RBACSwitcher from "components/common/Auth/RBACSwitcher";

const Dashboard = () => {
  return (
    <RBACSwitcher
      admin={<AdminStartupDashboard />}
      student={<StudentDashboard />}
      teacher={<TeacherDashboard />}
      school={<div>Dash Admin ecoles</div>}
      parent={<ParentDashboard />}
    />
  );
};

export default Dashboard;
